module.exports = __webpack_public_path__ + "img/not-viewed.9ecb58e5.svg";